module.exports = __webpack_public_path__ + "img/itapeva.6c5357f3.jpeg";